// 获取浏览器设备信息工具类
import { uaParse } from "@/intl-jdi-common-ssr/utils/uaParser";

const Unknown = 'Unknown';

// 网络类型检测
const detectNetworkType = (): string => {
  const ua = navigator.userAgent;
  const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
  if (!connection) return Unknown;
  const type = connection.effectiveType || connection.type;
  if (type) return type;
  // 更详细的网络类型判断
  if (/(WiFi|WLAN)/i.test(ua)) return 'WiFi';
  return Unknown;
};

const getDeviceInfoFromUA = () => {
  const result = uaParse();
  return {
    d_brand: result?.os?.name || Unknown,
    d_model: result?.platform?.vendor || Unknown,
    osVersion: result?.os?.version || Unknown,
    networkType: detectNetworkType(),
  };
};

export default getDeviceInfoFromUA;